import styled from 'styled-components';
import { Button } from '@tryhackme/thm-ui-components';

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.black};
  border-color: ${({ theme }) => theme.colors.secondary.lighter};
  color: ${({ theme }) => theme.colors.white};
`;

export const StyledAttackBoxTooltip = styled.div`
  left: 0;
  position: absolute;
  top: 4rem;
  text-align: center;
`;

export const StyledWrapperAttackBoxButton = styled.div`
  position: relative;
`;

export const StyledChildButton = styled(Button)`
  & > div > span {
    border-color: transparent ${({ theme }) => theme.colors.grey[200]} ${({ theme }) => theme.colors.grey[200]};
  }

  &:hover {
    & > div > span {
      border-color: transparent ${({ theme }) => theme.colors.black} ${({ theme }) => theme.colors.black};
    }
  }
`;
